export default __webpack_public_path__ + "4a663e5ebdba58167f4f1ca05fb5141c.png";